import {
  bindEvents,
  closeSecondaryMenuMobile,
  fadeInPrimaryMenuItems,
  fadeInSecondaryMenuDesktop,
  fadeOutSecondaryMenuItems,
  initiateFadeOutSecondaryMenuDesktop,
  openSecondaryMenuMobile,
  resetPrimaryMobileMenuItems
} from "./chunk.QMTIBSOF.js";
import {
  jb_menu_css_default
} from "./chunk.GED7CEHB.js";
import {
  isMobile
} from "./chunk.YDQDJZUC.js";
import {
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.MFPI4EPN.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  Animatable
} from "./chunk.27HF5Y4Z.js";
import {
  debounce,
  getEventElement
} from "./chunk.NKAUZW5M.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n,
  r as r2
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-menu/jb-menu.ts
var JbMenu = class extends Initiable(Animatable(r)) {
  constructor() {
    super(...arguments);
    this._isMobileMenu = false;
    this._primaryIndex = 0;
    this._secondaryIndex = 0;
  }
  firstUpdated() {
    this._isMobileMenu = isMobile();
    bindEvents(this.renderRoot);
    if (this.active) fadeInPrimaryMenuItems(this.renderRoot, this.renderRoot.querySelector(".primary-wrapper"));
    window.addEventListener(
      "resize",
      debounce(() => {
        this._isMobileMenu = isMobile();
        bindEvents(this.renderRoot);
        this.dispatchEvent(new CustomEvent("jbMenuFullFadeOut"));
        const isSecondaryMenuActive = this.renderRoot.querySelector(".secondary-wrapper.active");
        if (isSecondaryMenuActive) {
          closeSecondaryMenuMobile(this.renderRoot);
        }
      }, 100)
    );
  }
  hideMenu() {
    initiateFadeOutSecondaryMenuDesktop(
      this.shadowRoot,
      this.shadowRoot.querySelector(".primary-wrapper .active")
    );
  }
  loadSubmenu(submenu) {
    fadeInSecondaryMenuDesktop(this.renderRoot, submenu);
  }
  async reveal() {
    await super.reveal();
    if (this._isMobileMenu && this.renderRoot.querySelector(".secondary-wrapper.active")) {
      const secondaryMenuLists = this.renderRoot.querySelectorAll("jb-secondary-menu-list");
      const activeSecondaryMenuName = this.items[this._primaryIndex].submenu;
      const activeSecondaryMenuList = this.renderRoot.querySelector(`[data-belongs="${activeSecondaryMenuName}"]`);
      setTimeout(() => {
        this.renderRoot.querySelector(".secondary-wrapper.active")?.style.removeProperty("display");
      }, 400);
      setTimeout(() => {
        secondaryMenuLists.forEach((secondaryMenuList) => {
          secondaryMenuList.classList.remove("active");
        });
        activeSecondaryMenuList?.classList.add("active");
        activeSecondaryMenuList?.shadowRoot.querySelectorAll("jb-menu-item").forEach((menuItem) => {
          menuItem.classList.remove("hidden");
        });
      }, 200);
    }
  }
  _getLetterIndex(searchArray, letter, startIndex = 0) {
    for (let index = startIndex; index < searchArray.length; index += 1) {
      const node = Array.from(searchArray)[index];
      if (node.text.toLowerCase().startsWith(letter.toLowerCase())) {
        return index;
      }
    }
    if (startIndex !== 0) {
      for (let index = 0; index < startIndex; index += 1) {
        const node = Array.from(searchArray)[index];
        if (node.text.toLowerCase().startsWith(letter.toLowerCase())) {
          return index;
        }
      }
    }
    return -1;
  }
  _handleKeyboardEventPrimary(evt) {
    if (this._isMobileMenu) {
      this._handleKeyboardEventPrimaryMobile(evt);
      return true;
    }
    if (evt.shiftKey && evt.code === "Tab") {
      return true;
    }
    const menuNodes = this.shadowRoot.querySelectorAll(
      "jb-menu-item"
    );
    switch (evt.code) {
      case "ArrowUp":
        this._primaryIndex -= 1;
        if (this._primaryIndex < 0) {
          this._primaryIndex = menuNodes.length - 1;
        }
        this._secondaryIndex = 0;
        fadeInSecondaryMenuDesktop(this.renderRoot, menuNodes[this._primaryIndex].submenu);
        menuNodes[this._primaryIndex].focus();
        break;
      case "ArrowDown":
        this._primaryIndex += 1;
        if (this._primaryIndex >= menuNodes.length) {
          this._primaryIndex = 0;
        }
        this._secondaryIndex = 0;
        fadeInSecondaryMenuDesktop(this.renderRoot, menuNodes[this._primaryIndex].submenu);
        menuNodes[this._primaryIndex].focus();
        break;
      case "ArrowRight":
      case "Tab":
        evt.preventDefault();
        const selectedSecondaryMenu = this.renderRoot.querySelector(".secondary-wrapper")?.querySelector(".active");
        if (selectedSecondaryMenu) {
          selectedSecondaryMenu.focus();
        } else {
          if (evt.code === "Tab") {
            evt.target.blur();
            const firstServiceNavElement = document.querySelector(
              "jb-navigation jb-service-navigation jb-service-navigation-item:nth-of-type(2)"
            );
            firstServiceNavElement.focus();
          }
        }
        break;
      case "Home":
        this._primaryIndex = 0;
        fadeInSecondaryMenuDesktop(this.renderRoot, menuNodes[this._primaryIndex].submenu);
        menuNodes[this._primaryIndex].focus();
        this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        break;
      case "End":
        this._primaryIndex = menuNodes.length - 1;
        fadeInSecondaryMenuDesktop(this.renderRoot, menuNodes[this._primaryIndex].submenu);
        menuNodes[this._primaryIndex].focus();
        this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        break;
      case "Enter":
      case "Space":
        break;
      default:
        if (this._isValidKeyStroke(evt.key)) {
          if (this._getLetterIndex(menuNodes, evt.key) === -1) return true;
          this._primaryIndex = this._getLetterIndex(menuNodes, evt.key, this._primaryIndex + 1);
          menuNodes[this._primaryIndex].focus();
          this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
          fadeInSecondaryMenuDesktop(this.renderRoot, menuNodes[this._primaryIndex].submenu);
        }
        break;
    }
    return true;
  }
  _handleKeyboardEventPrimaryMobile(evt) {
    const menuNodes = this.shadowRoot.querySelectorAll(
      "jb-menu-item"
    );
    switch (evt.code) {
      case "Tab":
        evt.preventDefault();
        if (evt.shiftKey) {
          document.querySelector("jb-navigation")?.shadowRoot.querySelector('.top-left-navigation [role="button"]')?.focus();
          break;
        }
        this.renderRoot.querySelector("jb-service-navigation-item").shadowRoot.querySelector("a")?.focus();
        break;
      case "ArrowDown":
        this._primaryIndex += 1;
        if (this._primaryIndex >= this.items.length) {
          this._primaryIndex = 0;
        }
        menuNodes[this._primaryIndex].focus();
        break;
      case "ArrowUp":
        this._primaryIndex -= 1;
        if (this._primaryIndex < 0) {
          this._primaryIndex = this.items.length - 1;
        }
        menuNodes[this._primaryIndex].focus();
        break;
      case "Enter":
      case "Space":
      case "ArrowRight":
        if (evt.code === "Space" || evt.code === "ArrowRight") {
          if (menuNodes[this._primaryIndex].submenu) {
            openSecondaryMenuMobile(this.renderRoot, menuNodes[this._primaryIndex].submenu);
          } else {
            break;
          }
        }
        setTimeout(() => {
          this.renderRoot.querySelector("jb-secondary-menu-list.active")?.focus();
        }, 950);
        break;
      case "Home":
        this._primaryIndex = 0;
        menuNodes[this._primaryIndex].focus();
        this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        break;
      case "End":
        this._primaryIndex = this.items.length - 1;
        menuNodes[this._primaryIndex].focus();
        this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        break;
      default:
        if (this._isValidKeyStroke(evt.key)) {
          if (this._getLetterIndex(menuNodes, evt.key) === -1) return true;
          this._primaryIndex = this._getLetterIndex(menuNodes, evt.key, this._primaryIndex + 1);
          menuNodes[this._primaryIndex].focus();
          this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
          fadeInSecondaryMenuDesktop(this.renderRoot, menuNodes[this._primaryIndex].submenu);
        }
        break;
    }
    return true;
  }
  _handleKeyboardEventSecondary(evt) {
    if (this._isMobileMenu) {
      this._handleKeyboardEventSecondaryMobile(evt);
      return true;
    }
    const menuNodes = this.shadowRoot.querySelector("jb-secondary-menu-list.active").shadowRoot.querySelectorAll("jb-menu-item");
    let keyCode = evt.code;
    if (evt.shiftKey && evt.code === "Tab") {
      evt.preventDefault();
      keyCode = "ArrowLeft";
    }
    switch (keyCode) {
      case "ArrowLeft":
      case "Escape":
        evt.stopPropagation();
        this.renderRoot.querySelector(".active, .focused")?.focus();
        this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        break;
      case "ArrowDown":
        this._secondaryIndex += 1;
        if (this._secondaryIndex >= menuNodes.length) {
          this._secondaryIndex = 0;
        }
        menuNodes[this._secondaryIndex].focus();
        break;
      case "ArrowUp":
        this._secondaryIndex -= 1;
        if (this._secondaryIndex < 0) {
          this._secondaryIndex = menuNodes.length - 1;
        }
        menuNodes[this._secondaryIndex].focus();
        break;
      case "Home":
        this._secondaryIndex = 0;
        menuNodes[this._secondaryIndex].focus();
        this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        break;
      case "End":
        this._secondaryIndex = menuNodes.length - 1;
        menuNodes[this._secondaryIndex].focus();
        this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        break;
      case "Tab":
        evt.target.blur();
        const firstServiceNavElement = document.querySelector(
          "jb-navigation jb-service-navigation jb-service-navigation-item:nth-of-type(2)"
        );
        firstServiceNavElement.focus();
        break;
      default:
        if (this._isValidKeyStroke(evt.key)) {
          if (this._getLetterIndex(menuNodes, evt.key) === -1) return true;
          this._secondaryIndex = this._getLetterIndex(menuNodes, evt.key, this._secondaryIndex + 1);
          menuNodes[this._secondaryIndex].focus();
          this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        }
        break;
    }
    return true;
  }
  _handleKeyboardEventSecondaryMobile(evt) {
    const menuNodes = this.shadowRoot.querySelector("jb-secondary-menu-list.active")?.shadowRoot.querySelectorAll("jb-menu-item");
    if (!menuNodes) {
      this.renderRoot.querySelectorAll(".primary-wrapper jb-menu-item")[this._primaryIndex]?.focus();
      return true;
    }
    const currentSubMenu = this.items[this._primaryIndex].submenu;
    let keyCode = evt.code;
    if (evt.code === "Tab" && evt.shiftKey) {
      keyCode = "Shift+Tab";
    }
    switch (keyCode) {
      case "Tab":
        evt.preventDefault();
        fadeOutSecondaryMenuItems(this.renderRoot.querySelector("jb-secondary-menu-list.active"));
        closeSecondaryMenuMobile(this.renderRoot);
        resetPrimaryMobileMenuItems(this.renderRoot, currentSubMenu);
        fadeInPrimaryMenuItems(this.renderRoot, this.renderRoot.querySelector(".primary-wrapper"));
        document.querySelector("jb-navigation")?.shadowRoot.querySelector('.top-left-navigation [role="button"]')?.focus();
        break;
      case "ArrowDown":
        this._secondaryIndex += 1;
        if (this._secondaryIndex >= menuNodes.length) {
          this._secondaryIndex = 0;
        }
        menuNodes[this._secondaryIndex].focus();
        break;
      case "ArrowUp":
        this._secondaryIndex -= 1;
        if (this._secondaryIndex < -1) {
          this._secondaryIndex = menuNodes.length - 1;
        } else if (this._secondaryIndex === -1) {
          this.renderRoot.querySelector("jb-button-back").focus();
          this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
          break;
        }
        menuNodes[this._secondaryIndex]?.focus();
        this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        break;
      case "Escape":
      case "ArrowLeft":
      case "Shift+Tab":
        evt.stopPropagation();
        evt.preventDefault();
        this._secondaryIndex = 0;
        fadeOutSecondaryMenuItems(this.renderRoot.querySelector("jb-secondary-menu-list.active"));
        closeSecondaryMenuMobile(this.renderRoot);
        resetPrimaryMobileMenuItems(this.renderRoot, currentSubMenu);
        fadeInPrimaryMenuItems(this.renderRoot, this.renderRoot.querySelector(".primary-wrapper"));
        this.renderRoot.querySelectorAll("jb-menu-item")[this._primaryIndex]?.focus();
        break;
      case "Enter":
      case "Space":
        evt.target.click();
        if (evt.target.tagName === "JB-BUTTON-BACK") {
          this._secondaryIndex = 0;
          setTimeout(() => {
            resetPrimaryMobileMenuItems(this.renderRoot, currentSubMenu);
            this.renderRoot.querySelectorAll("jb-menu-item")[this._primaryIndex]?.focus();
          }, 150);
        }
        break;
      case "Home":
        evt.preventDefault();
        this._secondaryIndex = 0;
        menuNodes[this._secondaryIndex].focus();
        this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        break;
      case "End":
        evt.preventDefault();
        this._secondaryIndex = menuNodes.length - 1;
        menuNodes[this._secondaryIndex].focus();
        this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
        break;
      default:
        if (this._isValidKeyStroke(evt.key)) {
          if (this._isValidKeyStroke(evt.key)) {
            if (this._getLetterIndex(menuNodes, evt.key) === -1) return true;
            this._secondaryIndex = this._getLetterIndex(menuNodes, evt.key, this._secondaryIndex + 1);
            menuNodes[this._secondaryIndex].focus();
            this.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
          }
        }
        break;
    }
    return true;
  }
  _isValidKeyStroke(key) {
    return key.match(/^[A-z]$/);
  }
  _sendTrackingClick(texts, url, e) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e, {
      component_name: "header",
      interaction_effect: url ? "navigation" : "open",
      interaction_element: texts[texts.length - 1],
      interaction_result: url ?? "overlay",
      interaction_text: `hamburger__${texts.join("__")}`,
      interaction_type: "click"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  _trackMenu(evt) {
    evt.stopPropagation();
    const menuItem = getEventElement(evt, "JB-MENU-ITEM");
    const hasSubmenus = this.submenus?.some((e) => e.parent === menuItem.submenu);
    if (this._isMobileMenu && hasSubmenus) {
      return;
    }
    this._sendTrackingClick([menuItem.text.replace(/\s+/g, "-").toLowerCase()], menuItem.link.href, evt);
  }
  _trackServiceNavigation(evt) {
    const serviceNavigationItem = getEventElement(evt, "JB-SERVICE-NAVIGATION-ITEM");
    const serviceNavigationText = serviceNavigationItem.text ?? serviceNavigationItem.trackingLabel ?? serviceNavigationItem.textContent ?? serviceNavigationItem.children[0].textContent;
    const serviceNavigationItemUrl = serviceNavigationItem.link?.data?.action ? void 0 : serviceNavigationItem.link?.href;
    this._sendTrackingClick([serviceNavigationText.replace(/\s+/g, "-").toLowerCase()], serviceNavigationItemUrl, evt);
  }
  _trackSubMenu(evt) {
    evt.stopPropagation();
    const secondaryMenuList = getEventElement(evt, "JB-SECONDARY-MENU-LIST");
    const menuItem = getEventElement(evt, "JB-MENU-ITEM");
    const subMenuItemText = menuItem.text.replace(/\s+/g, "-").toLowerCase();
    const menuItemText = this.items.find((item) => item.submenu === secondaryMenuList.dataset.belongs).text.replace(/\s+/g, "-").toLowerCase();
    this._sendTrackingClick([menuItemText, subMenuItemText], menuItem.link.href, evt);
  }
  render() {
    return ke`<nav
      class="${Rt({
      "mobile-menu": this._isMobileMenu,
      "desktop-menu": !this._isMobileMenu
    })}"
    >
      <div class="wrapper">
        <div class="primary-wrapper">
          <div
            class="${Rt({
      "primary-menu-list": true,
      "initial-animations": this._isMobileMenu,
      primary: true
    })}"
            role="list"
            @keydown=${this._handleKeyboardEventPrimary}
          >
            ${this.items.map((item, indx) => {
      const link = { ...item.link };
      link.name = item.text;
      return ke`<jb-menu-item
                .link=${link}
                .submenu=${item.submenu}
                .tag=${item.tag}
                .text=${item.text}
                data-index=${indx}
                id="menu-${item.submenu}"
                role="listitem"
                type="primary"
                .notTabbable=${this._primaryIndex !== indx}
                @jb-link:clicked=${this._trackMenu}
                ?focused=${this._primaryIndex === indx}
                aria-label=${item.text}
                @mouseenter=${() => {
        this._primaryIndex = indx;
        this._secondaryIndex = 0;
      }}
                @focusin=${(evt) => {
        this._primaryIndex = indx;
        this._secondaryIndex = 0;
        evt.target.dispatchEvent(new MouseEvent("mouseenter", { bubbles: true, composed: true }));
      }}
                @focusout=${(evt) => {
        evt.target.dispatchEvent(new MouseEvent("mouseleave", { bubbles: true, composed: true }));
      }}
              ></jb-menu-item>`;
    })}
          </div>
          ${this.serviceNavigationItems && ke`
            <jb-service-navigation class="${Rt({
      hidden: !this.active
    })}">
              ${this.serviceNavigationItems.map(
      (item) => ke`<jb-service-navigation-item
                    .link=${item.link}
                    .icon=${item.icon}
                    .trackingLabel=${item.trackingLabel}
                    @jb-link:clicked=${this._trackServiceNavigation}
                    >${item.text}</jb-service-navigation-item
                  >`
    )}</slot>
            </jb-service-navigation>
          `}
        </div>

        ${this.submenus && ke`
          <div
            class="secondary-wrapper"
            @keydown=${this._handleKeyboardEventSecondary}
          >
            <div
              class="${Rt({
      hidden: !this._isMobileMenu,
      "submenu-header": true
    })}"
            >
              <jb-button-back
                role="button"
                .tabIndex=${-1}
                isWhite
                .text=${this.backLabel}
                @focusout=${() => {
      this.renderRoot.querySelector("jb-secondary-menu-list.active")?.shadowRoot.querySelector("jb-menu-item")?.focus();
    }}
              ></jb-button-back>
              <p class="title"></p>
              <p class="tag"></p>
            </div>

            ${this.submenus.map(
      (submenu) => ke`<jb-secondary-menu-list
                  data-belongs="${submenu.parent}"
                  .menuItems=${submenu.subitems}
                  .staticItem=${this._isMobileMenu ? submenu.staticItem : D}
                  .tabIndex=${-1}
                  .activeIndex=${this._secondaryIndex}
                  @jb-link:clicked=${this._trackSubMenu}
                  .ariaLabels=${{ label: submenu.parent.replace("-", " ") }}
                ></jb-secondary-menu-list>`
    )}
          </div>
        `}
      </div>
    </nav>`;
  }
};
JbMenu.styles = [reset_css_default, jb_menu_css_default];
JbMenu.shadowRootOptions = { ...r.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Boolean })
], JbMenu.prototype, "active", 2);
__decorateClass([
  n()
], JbMenu.prototype, "backLabel", 2);
__decorateClass([
  n({ type: Array })
], JbMenu.prototype, "items", 2);
__decorateClass([
  n({ type: Array })
], JbMenu.prototype, "serviceNavigationItems", 2);
__decorateClass([
  n({ type: Array })
], JbMenu.prototype, "submenus", 2);
__decorateClass([
  r2()
], JbMenu.prototype, "_isMobileMenu", 2);
__decorateClass([
  r2()
], JbMenu.prototype, "_primaryIndex", 2);
__decorateClass([
  r2()
], JbMenu.prototype, "_secondaryIndex", 2);
JbMenu = __decorateClass([
  customElement("jb-menu")
], JbMenu);

export {
  JbMenu
};
